import { render, staticRenderFns } from "./EntranceVideo.vue?vue&type=template&id=5aa8f84b&scoped=true&"
import script from "./EntranceVideo.vue?vue&type=script&lang=js&"
export * from "./EntranceVideo.vue?vue&type=script&lang=js&"
import style0 from "./EntranceVideo.vue?vue&type=style&index=0&id=5aa8f84b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa8f84b",
  null
  
)

export default component.exports